import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    monthId: Number
  }

  change(event) {
    const accountId = event.target.value
    const monthId = this.monthIdValue

    if (monthId && accountId) {
      window.location.href = `/accounts/${accountId}/months/${monthId}`
    }
  }
}

